module.exports = __webpack_public_path__ + "media/images/emoticons/pout-be54415dbf8c7d28a78ea82e19c80ffa.gif";